import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { toast } from "react-toastify";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import { route } from "../../../router/route";
import Pagination from "./../../../component/molecules/pagination";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import PretendardText from "../../../component/atoms/text/pretendardText";
import GrayBtn from "../../../component/atoms/button/grayBtn";

import RedBtn from "./../../../component/atoms/button/redBtn";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import Modal from "../../../component/templates/Modal";

import GroupApi from "../../../api/group.api";
import MemberApi from "../../../api/member.api";
import Empty from "../../../component/molecules/empty";
import AdminGroupManagePopup from "../../../component/templates/user/userAdmin/adminGroupManagePopup";
import moment from "moment";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const UserAdminInvite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_admin)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [selectedSort, setSelectedSort] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const sortList = [
    {
      title: "수락 완료",
      value: "CONFIRM",
    },
    {
      title: "수락 대기중",
      value: "AWAIT",
    },
    {
      title: "수락 거절",
      value: "REJECT",
    },
  ];

  const [groupPopupOpen, setGroupPopupOpen] = useState(false);

  const [selectedGroupValue, setSelectedGroupValue] = useState();
  const [selectedGroupId, setSelectedGroupId] = useState(0);
  const [operateGroupList, setOperateGroupList] = useState([]);

  // ---------- 데이터 관련 ---------- //
  const [adminInviteList, setAdminInviteList] = useState([]);

  useEffect(() => {
    getOperateGroupList();

    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setSelectedSort(searchParams.get("sort") ? searchParams.get("sort") : "");
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");

    getAdminInviteList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // 운영진 그룹 가져오기
  const getOperateGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        memberGroupType: "OPERATE",
      };

      const response = (await GroupApi.getList(data)).data.data.content;
      setOperateGroupList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (selectedGroupValue) {
      setGroupPopupOpen(true);
    }
  }, [selectedGroupValue]);

  const getAdminInviteList = async () => {
    try {
      const data = {
        page: Number(page),
        size: pagination.size,
        inviteFlag: "Active",
      };

      if (searchParams.get("sort")) {
        data.inviteStatus = searchParams.get("sort");
      }

      if (searchParams.get("keyword")) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await MemberApi.getList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          checked: false,
        };
      });

      setAdminInviteList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (adminInviteList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = adminInviteList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, adminInviteList]); /// eslint-disable-line react-hooks/exhaustive-deps

  //삭제관련
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const deleteFunc = async () => {
    try {
      let memberIdsTemp = checkedListStorage.map((item) => item.id);

      let data = {
        memberIds: memberIdsTemp,
      };
      await MemberApi.adminInviteDelete(data);

      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      getAdminInviteList();
      sessionStorageInit();
      navigate(
        `${route.user_admin_invite}?page=1&sort=${selectedSort}&keyword=${keyword}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  const cancelFunc = async () => {
    try {
      let memberIdsTemp = checkedListStorage.map((item) => item.id);

      let data = {
        memberIds: memberIdsTemp,
      };
      await MemberApi.adminInviteCancel(data);

      toast("초대 취소되었습니다.");
      setDeleteModalOpen(false);
      getAdminInviteList();
      sessionStorageInit();
      navigate(
        `${route.user_admin_invite}?page=1&sort=${selectedSort}&keyword=${keyword}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 사이드 바 영역 */}
        <SubSideBar title="운영진 그룹">
          <SubSideBarItem
            onClick={() => {
              sessionStorageInit();
              navigate(`${route.user_admin}?page=1&groupId=0&keyword=`);
            }}
          >
            전체
          </SubSideBarItem>
          {operateGroupList.length > 0 && (
            <span
              style={{
                width: "100%",
                height: 0.5,
                background: "rgba(255, 255, 255, 0.12)",
              }}
            />
          )}

          {operateGroupList.length > 0
            ? operateGroupList.map((item, index) => {
                return (
                  <SubSideBarItem
                    key={index}
                    icon="setting"
                    onClick={() => {
                      if (selectedGroupId === item.id) return;

                      sessionStorageInit();
                      navigate(
                        `${route.user_admin}?page=1&groupId=${item.id}&keyword=`
                      );
                    }}
                    settingHandler={() => {
                      if (isWriteAuthority) {
                        setSelectedGroupValue(item);
                      } else {
                        toast("권한이 없습니다.");
                      }
                    }}
                  >
                    {item.title}
                  </SubSideBarItem>
                );
              })
            : null}

          <SubSideBarItem
            selected={true}
            onClick={() => {
              navigate(route.user_admin_invite);
            }}
          >
            운영진 초대 내역
          </SubSideBarItem>

          {isWriteAuthority && (
            <SubSideBarFooter>
              <SubSideBarFooterText
                onClick={() => {
                  setSelectedGroupValue({
                    id: 0,
                  });
                }}
              >
                새 그룹 만들기
              </SubSideBarFooterText>
            </SubSideBarFooter>
          )}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>운영진 초대 내역</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount
              text={"운영진 초대 내역"}
              count={pagination.totalCount}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일), 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.user_admin_invite}?page=1&sort=${selectedSort}&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_admin_invite}?page=1&sort=${selectedSort}&keyword=${keyword}`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              {selectedSort === "AWAIT" ? (
                <RedBtn
                  style={{
                    backgroundColor: "#272829",
                  }}
                  onClick={() => {
                    cancelFunc();
                  }}
                >
                  초대 취소
                </RedBtn>
              ) : (
                <GrayBtn
                  onClick={() => {
                    setDeleteModalOpen(true);
                  }}
                >
                  내역 삭제
                </GrayBtn>
              )}
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="95px" />
              {/* 이름/아이디(이메일) */}
              <col width="290px" />
              {/* 그룹 */}
              <col width="226px" />
              {/* 초대일 */}
              <col width="229px" />
              {/* 상태 */}
              <col width="204px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...adminInviteList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          adminInviteList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    이름/아이디(이메일)
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    그룹
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    초대일
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        {sortList.map((item, index) => {
                          return (
                            <FilterTextWrapper key={index}>
                              <FilterText
                                onClick={() => {
                                  if (selectedSort === item.value) {
                                    navigate(
                                      `${route.user_admin_invite}?page=1&keyword=${keyword}&sort=`
                                    );
                                  } else {
                                    navigate(
                                      `${route.user_admin_invite}?page=1&keyword=${keyword}&sort=${item.value}`
                                    );
                                  }

                                  sessionStorageInit();
                                }}
                              >
                                {item.title}
                                {selectedSort === item.value ? (
                                  <img
                                    src="/assets/admin/icons/ico_selectbox_checked.svg"
                                    alt="선택됨"
                                  />
                                ) : null}
                              </FilterText>
                            </FilterTextWrapper>
                          );
                        })}
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {adminInviteList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "59px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 264,
                        }}
                      >
                        {item.name}/{item.email}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 180,
                        }}
                      >
                        {item?.groupList && item?.groupList?.length > 0
                          ? item.groupList.map((group, index02) => {
                              return (
                                <span key={index02}>
                                  {group.title}
                                  {index02 !== item.groupList.length - 1 &&
                                    ", "}
                                </span>
                              );
                            })
                          : "그룹 없음"}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.inviteDate).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          color:
                            item.inviteStatus === "CONFIRM"
                              ? "#aaa"
                              : item.inviteStatus === "AWAIT"
                              ? "#009bde"
                              : "#cf6679",
                        }}
                      >
                        {
                          sortList.find(
                            (item02) => item02.value === item.inviteStatus
                          )?.title
                        }
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {adminInviteList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.user_admin_invite}
            queryString={`sort=${selectedSort}&keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}

      {/* 그룹 정보 수정 팝업 */}
      {groupPopupOpen && (
        <AdminGroupManagePopup
          setPopupOpen={setGroupPopupOpen}
          selectedGroupValue={selectedGroupValue}
          getOperateGroupList={getOperateGroupList}
        />
      )}
    </>
  );
};

export default UserAdminInvite;

const SubSideBarFooter = styled.div.attrs((props) => {})`
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0px 16px;
  border-top: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const SubSideBarFooterText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
  cursor: pointer;
`;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
